export default {
  pt: {
    pageTitle: "Vídeo de verificação",
    titleReview: "Revisar vídeo",
    titleTake: "Por último, é a vez do vídeo",
    subtitleReview: "Confira se o número de série está legível e filmou a bike inteira.",
    subtitleTake: "Concentre maior tempo do número de série e no enquadramento da bike inteira.",
    playStepsTitle: "Reproduza os passos abaixo",
    continueButton: "Continuar",
    looksGoodButton: "Ficou legal!",
    recordAnotherButton: "Gravar outro",
    rule1Text: "Comece o vídeo focando no QR code.",
    rule2Text: "Procure um local iluminado.",
    rule3Text: "Não ultrapasse os 15 segundos",
    compressingLabel: "Comprimindo vídeo...",
    uploadingLabel: "Enviando vídeo...",
    handoffDescription:
      "Para gravar o vídeo, escaneie o QR code com a câmera do seu celular e continue por lá.",
  },

  en: {
    pageTitle: "Verification video",
    titleReview: "Review video",
    titleTake: "Finally, it's the video's turn",
    subtitleReview: "Check if the serial number is readable and filmed the entire bike.",
    subtitleTake: "Focus more time on the serial number and framing the entire bike.",
    playStepsTitle: "Play the steps below",
    continueButton: "Continue",
    looksGoodButton: "Looks good!",
    recordAnotherButton: "Record another",
    rule1Text: "Start the video focusing on the QR code.",
    rule2Text: "Look for a well-lit location.",
    rule3Text: "Don't exceed 15 seconds",
    compressingLabel: "Compressing video...",
    uploadingLabel: "Uploading video...",
    handoffDescription:
      "To record the video, scan the QR code with your phone's camera and continue from there.",
  },
};
